export default {
  FREE_COM_DOMAIN: 'free_com_domain',
  NO_DISCOUNTS: 'no_discounts',
};
